<template>
	<v-text-field :label="label" v-model="price_model" v-on:blur="onBlur()" ></v-text-field>
</template>
<script>
export default {
	name : "FloatInput",
	props : {
		label : {
			default : ""
		},
		price : {
			default : ""
		},
	},
	model: {
		prop: 'price',
		event: 'input'
	},
	data : () => ({
		price_model : ""
	}),
	watch : {
		"price" : function(n,o){
			this.price_model = parseFloat(this.price).toFixed(3)
		}
	}, 
	mounted(){
		this.price_model = parseFloat(this.price).toFixed(3)
	},
	methods : {
		onBlur(){
			this.price_model = this.price_model.replace(/[^\d.-]/g, '');
			if(this.price_model == ""){
				this.price_model = 0
			}
			this.price_model = parseFloat(this.price_model).toFixed(3)
			this.$emit("input", parseFloat(this.price_model) )
		}
	},
	computed : {
 
	}
}
</script>

